/* pt-metal: taps of THE KARAT SWITCH (the page types run, 2026-09-29). One select_promotion per tap on a door, pill, film, spot,
   counter or legit link (promotion_id metal-<part>, promotion_name <handle>|<target>|<part>, creative_slot the handle); sms, tel
   and chat links are counted once by snippets/hb-script (sms_click, phone_call_click, chat_open) and skipped here. view_promotion
   fires once when part 1 (or part 2 on page 2 and later) is a quarter in view. Loaded only by snippets/pt-metal.liquid. */
(function () {
  if (window.__ptMetal) return; window.__ptMetal = 1;
  function emit(n, p) { try { if (window.traxEmit) window.traxEmit(n, p); } catch (e) {} }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-pt]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (/^(sms|tel):/.test(href) || /direct\.lc\.chat/.test(href)) return;
    var c = a.closest('[data-ph]'), h = c ? c.getAttribute('data-ph') : '', k = a.getAttribute('data-pt');
    var t = href.split('?')[0].split('/').pop();
    var n = h + '|' + (k === 'row' || k === 'pills' ? t + '|' + k : k === 'film' ? 'film|' + t : k);
    emit('select_promotion', { promotion_id: 'metal-' + k, promotion_name: n, creative_slot: h, link_url: href });
  }, true);
  var b = document.querySelector('.pt-m');
  if (b && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) {
        var h = b.getAttribute('data-ph') || '';
        emit('view_promotion', { promotion_id: 'metal-view', promotion_name: h + '|view', creative_slot: h, link_url: location.pathname });
        io.disconnect(); break;
      }
    }, { threshold: 0.25 });
    io.observe(b);
  }
})();
